<div layout="row" class="tpp-and-right-column-container">
  <app-engagement> </app-engagement>

  <app-desktop-tpp-right-column
    *ngIf="engagementService.strategy.taskProcessContext.site"
    [taskProcessContext]="engagementService.strategy.taskProcessContext">
  </app-desktop-tpp-right-column>
</div>
